import React from "react";

import MessagesContainer from "./MessagesContainer";
import MessagesContainerV2 from "./MessagesContainerV2";

const MessageContainerWrapper = props => {
  const { isV2 } = props;

  return isV2 ? (
    <MessagesContainerV2 {...props} />
  ) : (
    <MessagesContainer {...props} />
  );
};

export default MessageContainerWrapper;
